import type { CertificatesPublicRoutes } from 'ulanano-cms-api/routes/certificates-public'
import { createGranularTreaty } from '../api-factory'

/**
 * Cliente da verificação pública de certificado — a única rota deste app que
 * atende quem NÃO tem conta (um empregador conferindo o diploma de um candidato).
 *
 * 🔴 `withCookies: true` aqui NÃO é sobre o cookie: a rota é sem sessão e ignora
 * qualquer credencial. É sobre o `origin`.
 *
 * O tenant desta rota sai do DOMÍNIO da requisição
 * (`api/src/lib/resolve-workspace-publico.ts`: `x-forwarded-host` → `origin` →
 * `host`), porque sem sessão não há quem diga qual workspace é. No SSR quem faz
 * a chamada é o servidor do app do aluno, falando com a API pelo endereço
 * INTERNO — se ninguém repassar o host do visitante, o resolvedor recebe o host
 * do container e devolve 400. `withCookies: true` é o único modo do
 * `api-factory` que instala o `headers: () => ({ origin: getRequestOrigin() })`,
 * e é esse `origin` que carrega o domínio público (o renderer repassa o `Host`
 * original ao proxiar — `renderer/src/student-proxy.ts`).
 *
 * Sem cookie o SSR desta página falharia em produção e passaria em dev, onde o
 * navegador fala direto com o Vite.
 *
 * ⚠️ Não trocar por um `treaty()` avulso: o cliente do `api-factory` é cacheado
 * por processo de propósito — cada `treaty()` novo abre seu próprio pool de
 * keep-alive e eles se acumulam (o comentário em `api-factory.ts` conta o caso).
 */
export const certificatesPublicApi = createGranularTreaty<CertificatesPublicRoutes>({
  withCookies: true,
})
